import React from 'react';
import { connect } from 'react-redux'
import {withTranslation} from "react-i18next";

class MessageBox extends React.Component {
	render(){
		const {t} = this.props;
		const classNames = this.props.isError ? "alert_box" : "message_box";
		return(
			this.props.status ?
				<div className={classNames}>
					<div>{t(this.props.message)}</div>
				</div>
			: null
		)
	}
}

// state를 해당 컴포넌트의 props로 연결
const mapStateToProps = (reducers) => {
	return{
		status: reducers.messageBox.status,
		message: reducers.messageBox.message,
		isError: reducers.messageBox.isError
	}
}

export default withTranslation()(connect(mapStateToProps, null)(MessageBox))